import { render } from "./Consiliere.vue?vue&type=template&id=71ffc2b9"
import script from "./Consiliere.vue?vue&type=script&lang=js"
export * from "./Consiliere.vue?vue&type=script&lang=js"

import "./Consiliere.vue?vue&type=style&index=0&id=71ffc2b9&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__